import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AdminLogin from "./Components/LoginAdmin/AdminLogin";
import { useState } from "react";
import Dashboard from "./Pages/Dashboard";
import ProtectedRouter from "./Components/LoginAdmin/ProductedRouter";
import VendorPage from "./Pages/VendorPage";
import VehiclePage from "./Pages/VehiclePage";
import SourcePage from "./Pages/SourcePage";
import Destination from "./Pages/Destination";
import DistanceMasterPage from "./Pages/DistanceMasterPage";
import RatePage from "./Pages/RatePage";
import VendorAdvancePage from "./Pages/VendorAdvance";
import PaymentPage from "./Pages/Payment";
import TripPage from "./Pages/TripPage";
import TripReportPage from "./Pages/TripReportPage";
import VendorAdvanceReport from "./Pages/VendorAdvanceReport";
import PaymentReportPage from "./Pages/PaymentReportPage";
import VehicleAdvance from "./Pages/VehicleAdvance";
import FixedRate from "./Pages/FixedRate";
import VehicleAdvanceReport from "./Pages/VehicleAdvanceReport";
import PaymentPreProcessing from "./Pages/PaymentPreProcessing";
import OwnerPayment from "./Pages/OwnerPayment";
import VendorAdvanceDeduction from "./Pages/VendorAdvanceDeduction";
import FixedSourcePage from "./Pages/FixedSource";
import FixedDestinationPage from "./Pages/FixedDestination";
import BillingInformation from "./Pages/BillingInformation";
import BillingViewPage from "./Pages/BillingViewPage";
import BillProcess from "./Pages/BillProcess";
import Wagon from "./Pages/Wagon";
import WagonReportPages from "./Pages/WagonReportPages";
import AppSettings from "./Pages/AppSettings";
import ContractorPage from "./Pages/Contractor";
import ContractorPayment from "./Pages/ContractorPayment";

function App() {
  const [logged, setLogged] = useState(() => {
    return !!localStorage.getItem("token");
  });

  const handleLogin = () => {
    setLogged(true);
    localStorage.setItem("isLoggedIn", "true");
  };

  const handleLogout = () => {
    setLogged(false);
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("token");
  };
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route
            path="/admin/login"
            element={<AdminLogin onLogin={handleLogin} />}
          />
          <Route
            path="/"
            element={
              <ProtectedRouter isLoggedIn={logged}>
                <Dashboard onLogout={handleLogout} />
              </ProtectedRouter>
            }
          />
          <Route
            path="/vendor"
            element={
              <ProtectedRouter isLoggedIn={logged}>
                <VendorPage />
              </ProtectedRouter>
            }
          />
          <Route
            path="/vehicle"
            element={
              <ProtectedRouter isLoggedIn={logged}>
                <VehiclePage />
              </ProtectedRouter>
            }
          />
          <Route
            path="/source"
            element={
              <ProtectedRouter isLoggedIn={logged}>
                <SourcePage />
              </ProtectedRouter>
            }
          />
          <Route
            path="/fixedsource"
            element={
              <ProtectedRouter isLoggedIn={logged}>
                <FixedSourcePage />
              </ProtectedRouter>
            }
          />
          <Route
            path="/destination"
            element={
              <ProtectedRouter isLoggedIn={logged}>
                <Destination />
              </ProtectedRouter>
            }
          />
          <Route
            path="/fixeddestination"
            element={
              <ProtectedRouter isLoggedIn={logged}>
                <FixedDestinationPage />
              </ProtectedRouter>
            }
          />
          <Route
            path="/distancemaster"
            element={
              <ProtectedRouter isLoggedIn={logged}>
                <DistanceMasterPage />
              </ProtectedRouter>
            }
          />
          <Route
            path="/rate"
            element={
              <ProtectedRouter isLoggedIn={logged}>
                <RatePage />
              </ProtectedRouter>
            }
          />
          <Route
            path="/advance"
            element={
              <ProtectedRouter isLoggedIn={logged}>
                <VendorAdvancePage />
              </ProtectedRouter>
            }
          />
          {/* <Route
            path="/trip"
            element={
              <ProtectedRouter isLoggedIn={logged}>
                <TripPage />
              </ProtectedRouter>
            }
          /> */}
          {/* <Route
            path="/payment"
            element={
              <ProtectedRouter isLoggedIn={logged}>
                <PaymentPage />
              </ProtectedRouter>
            }
          /> */}
          <Route
            path="/billing"
            element={
              <ProtectedRouter isLoggedIn={logged}>
                <BillingInformation />
              </ProtectedRouter>
            }
          />
          <Route
            path="/billingview"
            element={
              <ProtectedRouter isLoggedIn={logged}>
                <BillingViewPage />
              </ProtectedRouter>
            }
          />
          <Route
            path="/process"
            element={
              <ProtectedRouter isLoggedIn={logged}>
                <BillProcess />
              </ProtectedRouter>
            }
          />
          <Route
            path="/report/tripreport"
            element={
              <ProtectedRouter isLoggedIn={logged}>
                <TripReportPage />
              </ProtectedRouter>
            }
          />
          <Route
            path="/report/vendorAdvancereport"
            element={
              <ProtectedRouter isLoggedIn={logged}>
                <VendorAdvanceReport />
              </ProtectedRouter>
            }
          />
          <Route
            path="/report/paymentreport"
            element={
              <ProtectedRouter isLoggedIn={logged}>
                <PaymentReportPage />
              </ProtectedRouter>
            }
          />
          <Route
            path="/vehicleAdvance"
            element={
              <ProtectedRouter isLoggedIn={logged}>
                <VehicleAdvance />
              </ProtectedRouter>
            }
          />
          <Route
            path="/fixedrate"
            element={
              <ProtectedRouter isLoggedIn={logged}>
                <FixedRate />
              </ProtectedRouter>
            }
          />
          <Route
            path="/report/vehicleAdvance"
            element={
              <ProtectedRouter isLoggedIn={logged}>
                <VehicleAdvanceReport />
              </ProtectedRouter>
            }
          />
          <Route
            path="/report/Paymentpreprocess"
            element={
              <ProtectedRouter isLoggedIn={logged}>
                <PaymentPreProcessing />
              </ProtectedRouter>
            }
          />
          <Route
            path="/report/ownerpayment"
            element={
              <ProtectedRouter isLoggedIn={logged}>
                <OwnerPayment />
              </ProtectedRouter>
            }
          />
          <Route
            path="/wagon"
            element={
              <ProtectedRouter isLoggedIn={logged}>
                <Wagon />
              </ProtectedRouter>
            }
          />
           <Route
            path="/contractor"
            element={
              <ProtectedRouter isLoggedIn={logged}>
                <ContractorPage />
              </ProtectedRouter>
            }
          />
           <Route
            path="/contractorPayment"
            element={
              <ProtectedRouter isLoggedIn={logged}>
                <ContractorPayment />
              </ProtectedRouter>
            }
          />
          <Route
            path="/app_settings"
            element={
              <ProtectedRouter isLoggedIn={logged}>
                <AppSettings />
              </ProtectedRouter>
            }
          />
          <Route
            path="/report/wagon"
            element={
              <ProtectedRouter isLoggedIn={logged}>
                <WagonReportPages />
              </ProtectedRouter>
            }
          />
          {/* <Route
            path="/vendorAdvanceDeduction"
            element={
              <ProtectedRouter isLoggedIn={logged}>
                <VendorAdvanceDeduction />
              </ProtectedRouter>
            }
          /> */}
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
